import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

const FEATURE_KEY = 'basketballPracticeTimes';

/************************************************************************************
 *
 *                                      SLICE
 *
 ************************************************************************************
 */

interface BasketballPracticeTimesState {
  activeScheduleId?: number;
}

const initialState: BasketballPracticeTimesState = {
  activeScheduleId: undefined,
};

const basketballPractieTimesSlice = createSlice({
  name: FEATURE_KEY,
  initialState: initialState,
  reducers: {
    setActiveScheduleId: (state, action: PayloadAction<number>) => {
      state.activeScheduleId = action.payload;
    },
  },
});

/*
 * Export reducer for store configuration.
 */
const reducer = basketballPractieTimesSlice.reducer;
const actions = basketballPractieTimesSlice.actions;

const state = (rootState: any): BasketballPracticeTimesState =>
  rootState[FEATURE_KEY];

const activeScheduleIdSelector = createSelector(state, (state) => {
  return state?.activeScheduleId;
});

export { actions, activeScheduleIdSelector, reducer };
